
import { SET_SEARCHING_FOR_CUSTOMERS, SET_CUSTOMER_TRAITS_SEARCH_TERM, SET_CUSTOMER_EVENTS_SEARCH_TERM, SET_CUSTOMER_EVENTS_FILTER } from 'actions'

const initialState = {
  isSearchingForCustomer: false,
  traitSearchTerm: '',
  eventSearchTerm: '',
  eventFilter: ''
}

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case SET_SEARCHING_FOR_CUSTOMERS:
      return {
        ...state,
        isSearchingForCustomer: payload
      }
    case SET_CUSTOMER_TRAITS_SEARCH_TERM:
      return {
        ...state,
        traitSearchTerm: payload
      }
    case SET_CUSTOMER_EVENTS_SEARCH_TERM:
      return {
        ...state,
        eventSearchTerm: payload
      }
    case SET_CUSTOMER_EVENTS_FILTER:
      return {
        ...state,
        eventFilter: payload
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/application/customers.js